import React from "react";
import {benefitsSection, COLUMN_LAYOUT, TAB_GENERAL} from "../../../constants/company";
import {videoBanner, seo} from "../../../constants/company";
import CarouselSection from "./Components/Carousel";
import PartnersCarousel from "./Components/PartnersCarousel";
import Services from "./Components/Services";
import FAQWrapper from "../../Shared/wrappers/FAQWrapper";
import VideoBannerWrapper from "../../Shared/wrappers/VideoBannerWrapper";
import GetTheApp from "../../Shared/GetTheApp";
import ReviewsSection from "../../Shared/Reviews";
import Seo from "../../Shared/Seo";
import WhiteBoxesWrapper from "../../Shared/wrappers/WhiteBoxesWrapper";

const CompanyWrapper = () => {
  return (<div className="company-page">
    <Seo title={seo.title} description={seo.description} />
    <div className="bg-white">
    <VideoBannerWrapper   
        title={videoBanner.title}
        experience={videoBanner.experience}
        description={videoBanner.description}
        eventAction={videoBanner.eventLabel}
        eventLabel={videoBanner.eventLabel}
        altText={videoBanner.altText}
        video={videoBanner.video} 
      />
      <CarouselSection/>
      <PartnersCarousel/>
      <hr className="horizontal-line"/>
      <Services/>
      <GetTheApp altText={"Mavsign eclosing platform on two mobile devices"} />
      <div className="bg-gray">
      <WhiteBoxesWrapper 
        boxes={benefitsSection.boxes}
        title={benefitsSection.title}
        subtitle={benefitsSection.subtitle}
        boxLayout={COLUMN_LAYOUT}
      />
      </div>
      <ReviewsSection/>
      <FAQWrapper initialTab={TAB_GENERAL}/>
    </div>
  </div>);
}

export default CompanyWrapper;